import "../../utils/css/ClaimTimeline.css"
import React, { useState, useEffect } from "react";
import { Box, Typography, Collapse } from '@mui/material';
import {isMobile, formatTimelineDate, TimelineResponseStatusMap} from "../../utils/miscutils"
import { TimelineDot, TimelineConnector, getStatusConfig } from "../../utils/timelineElements";
import { TimelineApiHelper } from '../../apiHelpers/timelineApiHelper';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ClaimTimeline = ({ displayStatus, claimId, authToken }) => {
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(true);
  const [timelineSteps, setTimelineSteps] = useState([]);
  const [loading, setLoading] = useState(false);

  const mapTimelineStatus = (claimRemarks) => {

  const lowerRemarks = claimRemarks?.toLowerCase();
  return TimelineResponseStatusMap[lowerRemarks] || "Under Process";
  };

/*
  TEMPORARY NOTE:
  Timeline fetch is disabled for now due to edge cases in the backend data
  causing incorrect timeline rendering. Will re-enable once the API is stabilized.

   const fetchTimelineData = async () => {
    if (!claimId || !authToken) return;
    
    setLoading(true);
    try {
      const timelineApiHelper = new TimelineApiHelper({ authToken });
      const response = await timelineApiHelper.getClaimTimeline(claimId);
      
      if (response.isSuccess && response.data?.result) {
        const filteredTimelineData = response.data.result.filter(
          (item) => item.claimRemarks?.toLowerCase() !== "initiated"
        );
        const timelineData = filteredTimelineData.map((item, index, array) => ({
          title: mapTimelineStatus(item.claimRemarks),
          date: formatTimelineDate(item.timeStamp),
          status: index === array.length - 1 ? "current" : "completed",
          originalRemarks: item.claimRemarks
        }));
        
        setTimelineSteps(timelineData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

   useEffect(() => {
  fetchTimelineData();
  }, [claimId, authToken]);

*/
 


  const statusConfig = getStatusConfig(displayStatus);


  return (
    <div className="claim-timeline-container">
      <div className="claim-description-section">
        <div
          className="claim-icon-wrapper"
          style={{ backgroundColor: statusConfig.bgColor }}
        >
          <div style={{ color: statusConfig.iconColor }}>
            {statusConfig.icon}
          </div>
        </div>
        <div className="claim-description-content">
          <h3 className="claim-status-title">{statusConfig.title}</h3>
          <p className="claim-status-description">{statusConfig.description}</p>
        </div>
      </div>
     {/*
     NOTE: Timeline UI hidden for now due to backend edge cases.
     Will re-enable after API stabilization.
     loading ? (
        <Typography
          sx={{
            color: "#252D38",
            fontSize: { xs: 13, sm: 14, md: 16 },
            fontWeight: 400,
            mb: 2,
            mt: isMobile(window.innerWidth) ? 1 : 2,
            pl: isMobile(window.innerWidth) ? 7 : 8,
          }}
        >
          Loading timeline details...
        </Typography>
      ) : (
        <Box
          onClick={() => setIsTimelineExpanded(!isTimelineExpanded)}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 0.75,
            color: "#0066DC",
            fontSize: { xs: 13, sm: 14, md: 18 },
            fontWeight: 400,
            cursor: "pointer",
            mb: 2,
            mt: isMobile(window.innerWidth) ? 1 : 2,
            pl: isMobile(window.innerWidth) ? 7 : 8,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.7,
            }}
          >
            <Typography
              sx={{
                fontSize: "inherit",
                fontWeight: "inherit",
                userSelect: "none",
              }}
            >
              {isTimelineExpanded ? "Hide Timeline" : "Show Timeline"}
            </Typography>
            {isTimelineExpanded ? (
              <KeyboardArrowUpIcon sx={{ height: 30, width: 30 }} />
            ) : (
              <KeyboardArrowDownIcon sx={{ height: 30, width: 30 }} />
            )}
          </Box>
        </Box>
      )*/}

      <Collapse in={isTimelineExpanded}>
        <Box
          sx={{
            pl: isMobile(window.innerWidth) ? 3 : 4,
          }}
        >
          <Box sx={{ position: "relative", pl: 3, pr: 3 }}>
            {timelineSteps.map((step, index) => {
              const isLast = index === timelineSteps.length - 1;
              const nextStep = !isLast ? timelineSteps[index + 1] : null;
              const isNextCurrent = nextStep?.status === "current";
              return (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    gap: 2.5,
                    position: "relative",
                    pb: !isLast ? 3 : 0,
                    alignItems: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      flexShrink: 0,
                      minWidth: 30,
                      mt: 0.25,
                    }}
                  >
                    <TimelineDot status={step.status} stepTitle={step.title}/>
                    {!isLast && (
                      <TimelineConnector
                        status={step.status}
                        connectingToCurrent={isNextCurrent}
                        nextStepTitle={nextStep?.title}
                      />
                    )}
                  </Box>

                  <Box sx={{ flex: 1, pt: 0, mt: -0.25 }}>
                    <Typography
                      sx={{
                        fontSize: { xs: 14, sm: 15, md: 18 },
                        fontWeight: 400,
                        color: "#47566A",
                        mb: 0.5,
                        lineHeight: 1.3,
                      }}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 13, md: 15 },
                        fontWeight: 300,
                        color: "#47566A",
                        lineHeight: 1.4,
                      }}
                    >
                      {step.date}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Collapse>
    </div>
  );
};

export default ClaimTimeline;